"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewDataActionsContext = exports.NewDataController = exports.ItemsForTypeMap = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
class ItemsForTypeMap extends Map {
}
exports.ItemsForTypeMap = ItemsForTypeMap;
function NewDataController(props) {
    const { children } = props;
    const [, setChanged] = (0, react_1.useState)();
    const oneMinuteAgo = (0, moment_timezone_1.default)().subtract(1, 'minutes');
    // Controlled Data
    const itemsForType = (0, react_1.useRef)();
    const populateItemData = (0, react_1.useMemo)(() => (type, items) => {
        if (!itemsForType.current) {
            itemsForType.current = new ItemsForTypeMap();
        }
        itemsForType.current.set(type, items);
    }, []);
    const addItemsToType = (0, react_1.useMemo)(() => (type, items) => {
        var _a;
        const currentItems = (((_a = itemsForType.current) === null || _a === void 0 ? void 0 : _a.get(type)) || []).filter(i => i.createdDate.isAfter(oneMinuteAgo));
        const updatedItems = items === null || items === void 0 ? void 0 : items.map(i => (Object.assign(Object.assign({}, i), { createdDate: (0, moment_timezone_1.default)() })));
        currentItems.push(...updatedItems);
        populateItemData(type, currentItems);
        setChanged(new Date());
        return items;
    }, [populateItemData, oneMinuteAgo]);
    const updateItemsForType = (0, react_1.useMemo)(() => (type, items) => {
        var _a;
        let currentItems = (((_a = itemsForType.current) === null || _a === void 0 ? void 0 : _a.get(type)) || []).filter(i => i.createdDate.isAfter(oneMinuteAgo));
        currentItems = currentItems === null || currentItems === void 0 ? void 0 : currentItems.map(ci => {
            const item = items.find(i => ci.id === i.id);
            if (item) {
                item['createdDate'] = ci.createdDate;
                return item;
            }
            return ci;
        });
        populateItemData(type, currentItems);
        setChanged(new Date());
    }, [populateItemData, oneMinuteAgo]);
    const removeItemsFromType = (0, react_1.useMemo)(() => (type, items) => {
        var _a;
        const currentItems = (((_a = itemsForType.current) === null || _a === void 0 ? void 0 : _a.get(type)) || []).filter(i => i.createdDate.isAfter(oneMinuteAgo));
        const updatedItems = currentItems.filter(i => !items.find(ii => ii.id === i.id));
        populateItemData(type, updatedItems);
        setChanged(new Date());
    }, [populateItemData, oneMinuteAgo]);
    const getItemsForType = (0, react_1.useMemo)(() => (type) => {
        var _a;
        const currentItems = (((_a = itemsForType.current) === null || _a === void 0 ? void 0 : _a.get(type)) || []).filter(i => i.createdDate.isAfter(oneMinuteAgo));
        populateItemData(type, currentItems);
        return currentItems || [];
    }, [populateItemData, oneMinuteAgo]);
    const clearItemsForType = (0, react_1.useMemo)(() => (type) => {
        populateItemData(type, []);
        setChanged(new Date());
    }, [populateItemData]);
    const actionsCtx = (0, react_1.useMemo)(() => ({
        addItemsToType,
        getItemsForType,
        clearItemsForType,
        removeItemsFromType,
        updateItemsForType,
    }), [
        addItemsToType,
        getItemsForType,
        clearItemsForType,
        removeItemsFromType,
        updateItemsForType,
    ]);
    // Done
    return (0, react_1.useMemo)(() => (react_1.default.createElement(exports.NewDataActionsContext.Provider, { value: actionsCtx }, children)), [actionsCtx, children]);
}
exports.NewDataController = NewDataController;
exports.default = NewDataController;
exports.NewDataActionsContext = react_1.default.createContext(null);
